import React, { FC } from 'react';

import { CardButton, CardButtonProps, Grid, styled } from 'components/base';

const StyledCardButton = styled(CardButton)`
    &.minimalDisplay {
        width: 160px;
    }
    ,
    p {
        color: black;
    }
`;

type PersonalContentCategoryButtonProps = CardButtonProps & {
    minimalDisplay?: boolean;
};

const PersonalContentCategoryButton: FC<PersonalContentCategoryButtonProps> = ({
    minimalDisplay,
    ...rest
}) => (
    <Grid
        alignItems='stretch'
        display='flex'
        item
        {...(minimalDisplay ? { xs: 'auto' } : { xs: 12, md: 6, lg: 4 })}
        style={{ color: 'black' }}
    >
        <StyledCardButton
            {...rest}
            dense
            fullWidth
            stacked={minimalDisplay}
            style={{ color: 'black', border: '1px solid black' }}
        />
    </Grid>
);

export default PersonalContentCategoryButton;
